import React from "react";

const Answeritem = (props) => {
  const defaultvalue = (info) => {
    let checked = false;
    props.values.map((item) => {
      if (item.answer_id === info.id) {
        checked = true;
        props.selectedValue(item);
      } else {
      }
    });
    return checked;
  };
  return (
    <div className="item-answer">
      {props?.question?.pic ? (
        <div>
          <img src={props?.question?.pic} alt="exam" />
        </div>
      ) : null}
      <p>
        {props?.question?.length === 0 ? null : props?.question?.description}{" "}
        {props?.question?.right_answers > 1 ? (
          <span className="more-answers">(بیش از یک مورد)</span>
        ) : null}
      </p>

      <div className="list-answer">
        {props?.question?.answers?.length ? (
          props?.question?.length === 0 ? null : (
            props?.question?.answers.map((info) => (
              <label className="answers" htmlFor={info.id} key={info.id}>
                <input
                  checked={props.isChecked(info.id)}
                  type="checkbox"
                  name="answers"
                  id={info.id}
                  defaultChecked={defaultvalue(info)}
                  onChange={() => props.changeValue(info.id, info?.question_id)}
                />
                <span>{info?.description}</span>
              </label>
            ))
          )
        ) : (
          <div>
            <textarea
              id="answerTextField"
              className="examInput"
              onChange={(e) => {
                props.handleTextInput(e.target.value, props.question.id);
              }}
              placeholder="پاسخ خود را اینجا بنویسید"
              rows={10}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default Answeritem;
